mat-icon{color:#000;scale:.8}
/*# sourceMappingURL=toggle-shape-visibility-button.component.css.map */
